import React, { Component } from "react";
import ItemDetailView from "presentational/common/ItemDetailView";
import IconButtonView from "presentational/common/IconButtonView";
import config from "lib/fr-config";
import { getDeviceType } from "lib/deviceInfo";
import styles from "./ItemSummaryPanelView.scss";
import classNames from "classnames/bind";
import PropTypes from "prop-types";

const cx = classNames.bind(styles);

const desktopCss = config.css.desktop;
const mobileCss = config.css.mobile;

const cssXL = {
  root: {
    marginTop:
      -desktopCss.paddingBetweenHeaderbarAndFirstContent +
      desktopCss.paddingBetweenHeaderbarAndFirstContentForSplitView
  },
  buttonArea: {}
};
const cssXS = {
  root: {},
  buttonArea: {
    height: `calc(env(safe-area-inset-bottom) + ${mobileCss.headerBarHeightPX}px)`
  },
  buttonWrapper: {
    paddingBottom: "calc(env(safe-area-inset-bottom))"
  }
};

class ItemSummaryPanelView extends Component {
  static propTypes = {
    imageDataURL: PropTypes.string.isRequired,
    itemInfo: PropTypes.shape({
      category: PropTypes.string.isRequired,
      brand: PropTypes.string.isRequired,
      color: PropTypes.string.isRequired,
      tag: PropTypes.string.isRequired
    }).isRequired,
    onBackClick: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired
  };

  parseByType(type) {
    const { itemInfo } = this.props;

    switch (type) {
      case "tag":
        const rawTag = itemInfo.tag;
        const tag = rawTag.trim().replace(/[ ]/gi, "|");
        return tag;
      default:
        return itemInfo[type];
    }
  }

  mobileLayout() {
    const { imageDataURL, onBackClick, onSubmit } = this.props;
    const css = cssXS;
    const deviceType = getDeviceType();

    return (
      <div className={cx("root", deviceType)} style={css.root}>
        <ItemDetailView
          mode={"disableBtns"}
          imageSrc={imageDataURL}
          category={this.parseByType("category")}
          brand={this.parseByType("brand")}
          color={this.parseByType("color")}
          tag={this.parseByType("tag")}
          cardView
        />
        <div className={cx("button-area")} style={css.buttonArea}>
          <div style={css.buttonWrapper}>
            <IconButtonView type={"back"} onClick={onBackClick} />
          </div>
          <div style={css.buttonWrapper}>
            <IconButtonView type={"submit"} onClick={onSubmit} />
          </div>
        </div>
      </div>
    );
  }

  desktopLayout() {
    const { imageDataURL, onBackClick, onSubmit } = this.props;
    const css = cssXL;
    const deviceType = getDeviceType();

    return (
      <div className={cx("root", deviceType)} style={css.root}>
        <div className={cx("button-area")} style={css.buttonArea}>
          <IconButtonView type={"back"} onClick={onBackClick} />
          <IconButtonView
            type={"submit"}
            disableRightMargin
            onClick={onSubmit}
          />
        </div>
        <ItemDetailView
          mode={"disableBtns"}
          imageSrc={imageDataURL}
          category={this.parseByType("category")}
          brand={this.parseByType("brand")}
          color={this.parseByType("color")}
          tag={this.parseByType("tag")}
          cardView
        />
      </div>
    );
  }

  render() {
    return getDeviceType() === "mobile"
      ? this.mobileLayout()
      : this.desktopLayout();
  }
}

export default ItemSummaryPanelView;
